let mutationObserver;

const check = async () => {
  const container = document.querySelector('#gorgias-chat-container');
  const el = container?.querySelector('#gorgias-chat-container #chat-button');
  const isVisible = el && el.clientWidth > 0 && el.clientHeight > 0;
  document.body.classList[isVisible ? 'add' : 'remove']('has-chat');

  mutationObserver.disconnect();

  if (el) {
    mutationObserver.observe(container, {
      childList: true,
      subtree: true,
    });
    mutationObserver.observe(el, {
      attribute: true,
      attributeFilter: ['style'],
    });
  }
};

export const initChatDetection = () => {
  mutationObserver = new MutationObserver(() => {
    check();
  });

  check();

  const initGorgiasChatPromise = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise((resolve) => {
        window.addEventListener('gorgias-widget-loaded', resolve);
      });

  initGorgiasChatPromise.then(() => {
    check();

    window.GorgiasChat.on('ready', check);
  });
};
